import $ from 'jquery';
import AuthHeader from '../../helpers/AuthHeader';
import BuildQS from '../../helpers/BuildQS';
import config from '../../config/config';

export const territoriesService = {
    getRollingMonthsRevenue,
    getTerritories
};

const source = 'revdb';

function getRollingMonthsRevenue(filter){
    return config.live ? getRollingMonthsRevenueLive(filter) : getRollingMonthsRevenueStatic();
}

function getRollingMonthsRevenueLive(filter) {
  let baseUrl = config.apis.secStat+'/rolling_months_territory',
    qs = BuildQS({}),
    requestOptions = {
        headers: AuthHeader()
    };

  qs.mode = 'main';
  qs.date_start = filter.dateStart;
  qs.date_end = filter.dateEnd;
  qs.period = filter.period;
  qs.continent = filter.continent || '';
  qs.country_codes = Array.isArray(filter.countries) ? filter.countries.join(',') : '';
  qs.imprints=Array.isArray(filter.imprint) ? filter.imprint.join(',') : '';
  qs.customers=Array.isArray(filter.vendor) ? filter.vendor.join(','): '';
  qs.transaction_types=Array.isArray(filter.transactionType) ? filter.transactionType.map(t=>t.replace(/\,/g, '%2C')).join(','): '';
  
  baseUrl += '?' + $.param(qs);
  
  return fetch(baseUrl, requestOptions)
      .then(res=>res.json());
}

function getRollingMonthsRevenueStatic() {
    let baseUrl = `${config.apis.sales}/api/static/sec/rolling_months_revenue.json`;
    return fetch(baseUrl).then(res=>res.json());
}


function getTerritories(filter){
    return config.live ? getTerritoriesLive(filter) : getTerritoriesStatic(filter.continent, filter.territories, filter.period);
}

function getTerritoriesLive(filter) {
  let baseUrl = config.apis.secStat+'/overall_metrics',
    qs = BuildQS({}),
    requestOptions = {
        headers: AuthHeader()
    };
// console.log(filter);
  qs.mode = 'main';
  qs.period = filter.period;
  qs.date_start = filter.dateStart;
  qs.date_end = filter.dateEnd;
  qs.continent = filter.continent || '';
  qs.territories = Array.isArray(filter.primaryCountries) ? filter.primaryCountries.join(',') : '';
  qs.country_codes = Array.isArray(filter.countries) ? filter.countries.join(',') : '';
  qs.imprints=Array.isArray(filter.imprint) ? filter.imprint.join(',') : '';
  qs.customers=Array.isArray(filter.vendor) ? filter.vendor.join(','): '';
  qs.transaction_types=Array.isArray(filter.transactionType) ? filter.transactionType.map(t=>t.replace(/\,/g, '%2C')).join(','): '';

  
  baseUrl += '?' + $.param(qs);
  
  return fetch(baseUrl, requestOptions)
      .then(res=>res.json());
}

function getTerritoriesStatic(continent, territories, period) {
    const territory = territories ? 'country' : 'continent';
    let baseUrl = `${config.apis.sales}/api/static/sec/territories_metrics_${territory}.json`;
    return fetch(baseUrl).then(res=>res.json());
}